import ReactInputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';

export const DateField = ({
  value,
  setValue,
  label,
  id,
  error,
  helperText,
  size
}) => {
  return (
    <ReactInputMask
      id={id}
      alwaysShowMask
      mask="99/99/9999"
      value={value}
      onChange={e => setValue(e.target.value)}
    >
      <TextField
        variant="outlined"
        required
        error={error && error}
        helperText={error && helperText}
        label={label}
        size={size}
        InputProps={{
          style: {
            backgroundColor: 'white'
          }
        }}
        inputlabelprops={{
          shrink: true
        }}
      />
    </ReactInputMask>
  );
};
